import UpgradeMsgSvg from '@/../img/feature-upgrade.svg';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 500px;
  font-weight: 600;
  color: #101938;
  line-height: 1;
  height: 100%;
  width: 100%;
`;

const Title = styled.div`
  font-size: 24px;
  margin-top: 40px;
`;

const Message = styled.div`
  text-align: center;
  font-size: 14px;
  line-height: 1.57;
  color: rgba(0, 0, 0, 0.85);
  margin-top: 18px;
`;

const Contact = styled.div`
  font-size: 18px;
  margin-top: 40px;
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-row-gap: 18px;
`;

/**
 * This component renders a svg image telling the user he/she will be able to
 * access this feature after an upgrade
 * TODO: Move this to @widgets if used outside the ListViewer
 */
export function UpgradeRequiredMessage() {
  return (
    <Wrapper>
      <UpgradeMsgSvg />
      <Title>This is a feature upgrade</Title>
      <Message>
        <div>
          Interested in learning more about our license management solutions?
        </div>
        <div>
          Give us a call or send an email to get in touch with our sales team
        </div>
      </Message>
      <Contact>
        <div>Phone: (858) 333-7835</div>
        <div>Email: info@deckard.com</div>
      </Contact>
    </Wrapper>
  );
}
